import { faFileAlt, faInfoCircle, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React, { useState } from 'react'
import NumberFormat from 'react-number-format';
import { Link, useHistory, useParams } from 'react-router-dom';
import { Alert, Badge, Button, Card, CardBody, CardHeader, Col, Collapse, DropdownItem, DropdownMenu, DropdownToggle, Media, Row, UncontrolledDropdown } from 'reactstrap';
import { findMyPaysAsManager } from '../../../../helpers/api/finance';
import useSWRFetchPagination from '../../../../helpers/hooks/useSWRFetchPagination';
import { isIterableArray } from '../../../../helpers/utils';
import ButtonIcon from '../../../common/ButtonIcon';
import Calendar from '../../../common/Calendar';
import Flex from '../../../common/Flex';
import PageHeader from '../../../common/PageHeader';
import { Message, Or, PreloadState } from '../../../UI/preloading/PreloadState';

const CondominiumPayments = () => {

    const history = useHistory();
    const { charge, id } = useParams();
    const [showDetails, setShowDetails] = useState(false);
    const [params] = useState({
        condominiumCharge: charge,
    })
    const {
        data,
        error,
        isLoading,
    } = useSWRFetchPagination(findMyPaysAsManager, params);

    const months = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

    const renderItems = () => data.map((payment, i) => {
        let date = new Date(payment?.created_at);
        return <Row key={i} className={payment?.status === 'processing' ? 'border-top py-3' : payment?.status === 'canceled' ? 'alert-danger border-top py-3' : payment?.status === 'refused' ? 'alert-danger border-top py-3' : 'alert-success border-top py-3'}>
            <Col>
                <Row>
                    <Col>
                        <Row>
                            <Col xs={9} className='d-flex align-items-center'>
                                <Media>
                                    <Calendar month={months[date.getMonth()]} day={date.getDate().toString()} />
                                    <Media body className="position-relative pl-3 align-self-center">
                                        <p className='mb-0'>Pago mensual del propietario {payment?.user?.firstname} {payment?.user?.lastname}</p>
                                        <p className='fs--1 mb-0 font-weight-bolder'>{payment?.status === 'processing' ? 'Pendiente' : payment?.status === 'canceled' ? 'Cancelado por propietario' : payment?.status === 'refused' ? 'Pago rechazado' : 'Aprobado'}</p>
                                    </Media>
                                </Media>
                            </Col>
                            <Col xs={3} className=' d-flex align-items-center justify-content-end'>
                                <Media>
                                    <Media body className="border-left position-relative pl-3">
                                        <p className='mb-0 font-weight-bolder'>Monto</p>
                                        <p className="fs--1 mb-0 text-600"><NumberFormat displayType='text' value={payment?.amount} thousandSeparator decimalScale={2} fixedDecimalScale prefix='$ ' /></p>
                                    </Media>
                                </Media>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs='auto' className="d-sm-flex align-items-center justify-content-end">
                        <UncontrolledDropdown direction="left" className="d-inline-block ml-2">
                            <DropdownToggle color="falcon-default" size="sm">
                                <FontAwesomeIcon icon="ellipsis-h" />
                            </DropdownToggle>
                            <DropdownMenu right>
                                <Link to={{ pathname: `${charge}/${payment?.id}`, state: { payment: payment } }} className="dropdown-item">
                                    <DropdownItem>Ver detalles</DropdownItem>
                                </Link>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    </Col>
                </Row>
            </Col>
        </Row>
    });

    const service = {
        type: 'Sencillo',
        description: 'Para condominios menores a 200 propiedades.',
        price: {
            month: 1252100000,
            year: 323144324
        },
        button: {
            text: 'Start free trial',
            color: 'outline-primary'
        },
        featureTitle: 'Acceso a características únicas:',
        features: [
            { title: 'Muro de noticias' },
            { title: 'Centro de sugerencias' },
            {
                title: 'Áreas comunes',
                badge: {
                    text: 'Nuevo',
                    color: 'soft-success'
                }
            },
            { title: 'Finanzas del condominio' },
        ],
    }

    const PricingRow = ({ children }) =>
        <li className="py-1">
            <FontAwesomeIcon icon="check" transform="shrink-2" className="text-success" /> {children}
        </li>

    return <>
        <PageHeader
            title='Servicio contratado'
            titleTag="h2"
            description="Visualiza y gestiona los pagos del servicio contratado por el condominio."
            className="mb-3"
            col={{ lg: 9 }}
        />
        <Card className='mb-3'>
            <CardHeader className='bg-light d-flex justify-content-between align-items-center'>
                <h5>Información del servicio contratado</h5>
                <Flex align='center'>
                    <ButtonIcon icon={faUndo} color='falcon-default' className='mr-2' tag={Link} to={`/root/condominiums/${id}/status`} >Volver a estado del servicio</ButtonIcon>
                    <ButtonIcon icon={faFileAlt} color='falcon-default' onClick={() => setShowDetails(!showDetails)}>{showDetails ? 'Ocultar detalles' : 'Ver detalles'}</ButtonIcon>
                </Flex>
            </CardHeader>
            <CardBody className={classNames({ 'p-0': !showDetails })}>
                <Collapse isOpen={showDetails}>
                    <Row>
                        <Col>
                            <div className="h-100" >
                                <Row>
                                    <Col>
                                        <div className="text-center p-4">
                                            <h3 className="font-weight-normal my-0">{service.type}</h3>
                                            <p className="mt-3">{service.description}</p>
                                            <h2 className="font-weight-medium my-4">
                                                <sup className="font-weight-normal fs-2 mr-1">$</sup>
                                                <NumberFormat value={service.price.month} thousandSeparator decimalScale={2} fixedDecimalScale displayType='text' />
                                                <small className="fs--1 text-700">/ Mensual</small>
                                            </h2>
                                        </div>
                                    </Col>
                                    <Col>
                                        <div className={classNames('text-left px-sm-4 py-4')}>
                                            <h5 className="font-weight-medium fs-0">{service.featureTitle}</h5>
                                            <ul className="list-unstyled mt-3">
                                                {isIterableArray(service.features) &&
                                                    service.features.map((feature, index) => (
                                                        <PricingRow key={index}>
                                                            {feature.title}{' '}
                                                            {feature.badge && (
                                                                <Badge color={feature.badge.color} pill className="ml-1">
                                                                    {feature.badge.text}
                                                                </Badge>
                                                            )}
                                                        </PricingRow>
                                                    ))}
                                            </ul>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Collapse>
            </CardBody>
        </Card>
        <Card>
            <CardHeader className='bg-light'>
                <h5>Historial de pagos del condominio</h5>
            </CardHeader>
            <CardBody className='fs--1 pt-0'>
                <PreloadState cond={isIterableArray(data)} loading={isLoading}>
                    <Or value={true}>
                        {renderItems()}
                    </Or>
                    <Or value={false} cond={!!error}>
                        <Message value={false} color={'info'} className='p-3' align='left' icon={faInfoCircle}>
                            Aún no hay pagos para mostrar.
                        </Message>
                        <Or value={true}>
                            <Alert color="danger" className="mb-0">
                                Esta página no está disponible
                                <Button data-testid="Button" color="link" size="sm" className="ml-1 pl-0" onClick={() => history.goBack()}>
                                    Volver
                                </Button>
                            </Alert>
                        </Or>
                    </Or>
                </PreloadState>
            </CardBody>
        </Card>
    </>
}

export default CondominiumPayments;